export default {
  root: {
    borderWidth: 10,
  },
}
